import Swiper, { Manipulation, Navigation } from 'swiper';
import 'swiper/css';
import renderProductCards from '../utils/render-product-cards.js';
import { getResults } from '../modules/searchanise.js';
import Product from '../models/Product.js';
import ProductCard from '../components/svelte/ProductCard.svelte';

const selectors = {
  collectionTab: '[data-collection-tab]',
  collectionGroup: '[data-collection-group]',
  carouselWrapper: '[data-tabbed-collections]',
  viewAllButton: '[data-view-button]',
};

class TabbedCollections extends HTMLElement {
  constructor() {
    super();

    this.createObserver();

    this.viewAllButton = document.querySelector(selectors.viewAllButton);
  }

  createObserver() {
    this.observer = new IntersectionObserver((entries, observer) => {
      if (entries[0].isIntersecting) {
        this.render();
        observer.unobserve(this);
      }
    });

    this.observer.observe(this);
  }

  render() {
    this.collectionTab = this.querySelector(selectors.collectionTab);
    this.collectionGroup = this.querySelector(selectors.collectionGroup);
    this.collectionTabAll = this.querySelectorAll(selectors.collectionTab);
    this.collectionGroupAll = [
      ...this.querySelectorAll(selectors.collectionGroup),
    ];

    this.carouselWrappers = document.querySelectorAll(
      selectors.carouselWrapper
    );

    this.init();
  }

  init() {
    this.initCarousels();
    this.initTabs();
    renderProductCards();
  }

  initTabs() {
    this.collectionGroup.classList.remove('hidden');
    this.collectionTab.classList.remove('border-transparent');
    this.collectionTab.classList.add('border-brand-blue');

    // Set the view all button to the tab[0] collection handle.
    this.viewAllButton.setAttribute(
      'href',
      `/collections/${this.collectionTab.dataset.collectionTab}`
    );

    this.collectionTabAll.forEach(item => {
      item.addEventListener('click', e => {
        e.preventDefault();

        this.collectionTabAll.forEach(tab => {
          tab.classList.remove('border-brand-blue');
          tab.classList.add('border-transparent');
        });

        item.classList.remove('border-transparent');
        item.classList.add('border-brand-blue');

        this.collectionGroupAll.forEach(current => {
          current.classList.remove('hidden');
          current.classList.remove('block');
          if (item.dataset.collectionTab === current.dataset.collectionGroup) {
            current.classList.add('block');

            this.viewAllButton.setAttribute(
              'href',
              `/collections/${item.dataset.collectionTab}`
            );
          } else {
            current.classList.add('hidden');
          }
        });
      });
    });
  }

  static renderCarousel(wrapper) {
    if (typeof wrapper.dataset.collectionHandle === 'undefined') {
      return;
    }

    const $next = wrapper.parentElement.querySelector('.swiper-button-next');
    const $prev = wrapper.parentElement.querySelector('.swiper-button-prev');

    // eslint-disable-next-line no-new
    new Swiper(wrapper, {
      modules: [Navigation, Manipulation],
      freeMode: true,
      slidesPerView: 1,
      spaceBetween: 10,
      preloadImages: false,
      on: {
        init(swiper) {
          TabbedCollections.loadProductsFromSearchanise(
            wrapper.dataset.collectionHandle,
            swiper
          );
        },
      },
      breakpoints: {
        1024: {
          slidesPerView: 4,
        },
      },
      navigation: {
        nextEl: $next,
        prevEl: $prev,
      },
    });
  }

  static loadProductsFromSearchanise(handle, swiper, page = 1) {
    getResults({
      collection: handle,
      maxResults: 6,
      startIndex: page === 1 ? 0 : (page - 1) * 6,
    }).then(response => {
      // We're at the end – do nothing.
      if (response.currentItemCount === 0) {
        return;
      }

      response.items
        .map(item => Product.fromSearchanise(item))
        .forEach(product => {
          const dynamicSlideAlreadyExists = document.querySelector(
            `[data-dynamic-product-slide="page-${page}--${product.id}"]`
          );

          // Avoid putting multiple product cards in the same slide if
          // there's a race condition when loading products, or if
          // the same page is loaded multiple times.
          if (dynamicSlideAlreadyExists) {
            return;
          }

          swiper.appendSlide([
            `<li class="swiper-slide !h-auto">
              <div class="relative h-full" data-dynamic-product-slide="page-${page}--${product.id}"></div>
            </li>`,
          ]);

          // eslint-disable-next-line no-new
          new ProductCard({
            target: document.querySelector(
              `[data-dynamic-product-slide="page-${page}--${product.id}"]`
            ),
            props: {
              product,
              doNotRender: ['reviews'],
            },
          });
        });

      // If it's the initial render, remove the ghost cards
      if (page === 1) {
        const slidesToRemove = [];
        swiper.slides.forEach((slide, i) => {
          if (slide.querySelector('[data-ghost-card]')) {
            slidesToRemove.push(i);
          }
        });

        swiper.removeSlide(slidesToRemove);
      }

      swiper.update();
    });
  }

  initCarousels() {
    this.carouselWrappers.forEach(wrapper => {
      const carouselObserver = new IntersectionObserver((entries, observer) => {
        if (entries[0].isIntersecting && getComputedStyle(wrapper) !== 'none') {
          TabbedCollections.renderCarousel(wrapper);
          observer.unobserve(wrapper);
        }
      });

      carouselObserver.observe(wrapper);
    });
  }
}

customElements.define('tabbed-collections', TabbedCollections);
